export const STANDARD_TEXT_LIST_FOR_MODAL_DELETE = ['Everyone will lose this and underlying data', 'This can not be undone'];
